/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { InOutType } from 'app/shared/model/enumerations/in-out-type.model';
import { createEntity, getEntity, reset, updateEntity } from './cash-transaction.reducer';

export const CashTransactionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const cashTransactionEntity = useAppSelector(state => state.cashTransaction.entity);
  const loading = useAppSelector(state => state.cashTransaction.loading);
  const updating = useAppSelector(state => state.cashTransaction.updating);
  const updateSuccess = useAppSelector(state => state.cashTransaction.updateSuccess);
  const inOutTypeValues = Object.keys(InOutType);

  const handleClose = () => {
    navigate(`/cash-transaction${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.tenderedAmount !== undefined && typeof values.tenderedAmount !== 'number') {
      values.tenderedAmount = Number(values.tenderedAmount);
    }
    if (values.qty1 !== undefined && typeof values.qty1 !== 'number') {
      values.qty1 = Number(values.qty1);
    }
    if (values.qty2 !== undefined && typeof values.qty2 !== 'number') {
      values.qty2 = Number(values.qty2);
    }
    if (values.qty5 !== undefined && typeof values.qty5 !== 'number') {
      values.qty5 = Number(values.qty5);
    }
    if (values.qty10 !== undefined && typeof values.qty10 !== 'number') {
      values.qty10 = Number(values.qty10);
    }
    if (values.qty20 !== undefined && typeof values.qty20 !== 'number') {
      values.qty20 = Number(values.qty20);
    }
    if (values.qty50 !== undefined && typeof values.qty50 !== 'number') {
      values.qty50 = Number(values.qty50);
    }
    if (values.qty100 !== undefined && typeof values.qty100 !== 'number') {
      values.qty100 = Number(values.qty100);
    }
    if (values.qty200 !== undefined && typeof values.qty200 !== 'number') {
      values.qty200 = Number(values.qty200);
    }
    if (values.qty500 !== undefined && typeof values.qty500 !== 'number') {
      values.qty500 = Number(values.qty500);
    }
    if (values.qty1000 !== undefined && typeof values.qty1000 !== 'number') {
      values.qty1000 = Number(values.qty1000);
    }
    if (values.qty2000 !== undefined && typeof values.qty2000 !== 'number') {
      values.qty2000 = Number(values.qty2000);
    }
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...cashTransactionEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
          lastUpdated: displayDefaultDateTime(),
        }
      : {
          inOutType: 'IN',
          ...cashTransactionEntity,
          microSec: convertDateTimeFromServer(cashTransactionEntity.microSec),
          timestampEntry: convertDateTimeFromServer(cashTransactionEntity.timestampEntry),
          lastUpdated: convertDateTimeFromServer(cashTransactionEntity.lastUpdated),
          hospital: cashTransactionEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.cashTransaction.home.createOrEditLabel" data-cy="CashTransactionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.cashTransaction.home.createOrEditLabel">Create or edit a CashTransaction</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="cash-transaction-id"
                  label={translate('tinyMedicRestApp.cashTransaction.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.inOutType')}
                id="cash-transaction-inOutType"
                name="inOutType"
                data-cy="inOutType"
                type="select"
              >
                {inOutTypeValues.map(inOutType => (
                  <option value={inOutType} key={inOutType}>
                    {translate(`tinyMedicRestApp.InOutType.${inOutType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.tenderedAmount')}
                id="cash-transaction-tenderedAmount"
                name="tenderedAmount"
                data-cy="tenderedAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty1')}
                id="cash-transaction-qty1"
                name="qty1"
                data-cy="qty1"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty2')}
                id="cash-transaction-qty2"
                name="qty2"
                data-cy="qty2"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty5')}
                id="cash-transaction-qty5"
                name="qty5"
                data-cy="qty5"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty10')}
                id="cash-transaction-qty10"
                name="qty10"
                data-cy="qty10"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty20')}
                id="cash-transaction-qty20"
                name="qty20"
                data-cy="qty20"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty50')}
                id="cash-transaction-qty50"
                name="qty50"
                data-cy="qty50"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty100')}
                id="cash-transaction-qty100"
                name="qty100"
                data-cy="qty100"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty200')}
                id="cash-transaction-qty200"
                name="qty200"
                data-cy="qty200"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty500')}
                id="cash-transaction-qty500"
                name="qty500"
                data-cy="qty500"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty1000')}
                id="cash-transaction-qty1000"
                name="qty1000"
                data-cy="qty1000"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.qty2000')}
                id="cash-transaction-qty2000"
                name="qty2000"
                data-cy="qty2000"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.active')}
                id="cash-transaction-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.microSec')}
                id="cash-transaction-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.timestampEntry')}
                id="cash-transaction-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.lastUpdated')}
                id="cash-transaction-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cashTransaction.cursor')}
                id="cash-transaction-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="cash-transaction-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.cashTransaction.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/cash-transaction" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CashTransactionUpdate;
